import OrigenDeudaUpdate from './OrigenDeudaUpdate'
export {OrigenDeudaUpdate}
export default OrigenDeudaUpdate
